// extracted by mini-css-extract-plugin
export var formWrap = "reg-module--form-wrap--28e49";
export var reg = "reg-module--reg--6c530";